module.exports = __webpack_public_path__ + "static/media/ic-address.3dadf49d.svg";